// This file is auto-generated. Do not edit manually.

import { z } from "zod";

export const UuidSchema = z.string().uuid();

export const PaginationInfoSchema = z.object({
  total: z.number(),
  limit: z.number(),
  offset: z.number(),
  hasMore: z.boolean(),
});
export type PaginationInfo = z.infer<typeof PaginationInfoSchema>;

export const StringMapSchema = z.record(z.string());
export type StringMap = z.infer<typeof StringMapSchema>;

export const ZodErrorMessageSchema = z.array(StringMapSchema);
export type ZodErrorMessage = z.infer<typeof ZodErrorMessageSchema>;

export const ResponseMessageSchema = z.union([
  z.string(),
  ZodErrorMessageSchema,
]);
export type ResponseMessage = z.infer<typeof ResponseMessageSchema>;

export const AuthTokenSchema = z.object({
  authToken: z.string(),
  refreshToken: z.string(),
});
export type AuthToken = z.infer<typeof AuthTokenSchema>;

export const StatusSchema = z.enum(["success", "error"]);
export type Status = z.infer<typeof StatusSchema>;

const ErrorCodes = z.enum([
  "PARTNER_DEACTIVATED",
  "REQUEST_CANNOT_BE_MODIFIED",
  "ACCOUNT_ACCESS_REVOKED",
  "MAINTENANCE_MODE",
  "VIEWINGS_DISPATCH_DISABLED",
  "VIEWINGS_DISPATCH_STALE_VERSION",
  "VIEWINGS_DISPATCH_OWNERSHIP_FAILURE",
  "VIEWINGS_DISPATCH_INVALID_TRANSITION",
  "VIEWINGS_DISPATCH_MISSING_ACTIVE_ATTEMPT",
  "VIEWINGS_DISPATCH_NOT_FOUND",
  "VIEWINGS_DISPATCH_VALIDATION_FAILED",
  "VIEWINGS_DISPATCH_INSPECTOR_EMAIL_EXISTS",
  "VIEWINGS_DISPATCH_INSPECTOR_PHONE_EXISTS",
  "INSPECTOR_OTP_REQUEST_THROTTLED",
  "INSPECTOR_OTP_VERIFY_THROTTLED",
  "INSPECTOR_EVIDENCE_INVALID_METADATA",
  "INSPECTOR_EVIDENCE_EXACT_JPEG_REQUIRED",
  "INSPECTOR_EVIDENCE_INVALID_JPEG",
  "INSPECTOR_EVIDENCE_HASH_MISMATCH",
  "INSPECTOR_EVIDENCE_METADATA_MISMATCH",
  "INSPECTOR_EVIDENCE_ATTEMPT_INACTIVE",
  "INSPECTOR_EVIDENCE_ID_CONFLICT",
  "INSPECTOR_EVIDENCE_FILE_MISSING",
  "INSPECTOR_EVIDENCE_RECEIVED_IMMUTABLE",
  "INSPECTOR_COMPLETION_EVIDENCE_REQUIRED",
  "INSPECTOR_COMPLETION_COMPLETED_ELSEWHERE",
  "INSPECTOR_COMPLETION_ID_CONFLICT",
]);
export type ErrorCodes = z.infer<typeof ErrorCodes>;
const BaseApiResponseSchema = z.object({
  status: z.enum(["success", "error"]),
  code: ErrorCodes.optional(),
  message: ResponseMessageSchema.optional(),
  pagination: PaginationInfoSchema.optional(),
});

// Create a function to generate the full ApiResponseSchema with a generic data type
export const ApiResponseSchema = <T extends z.ZodTypeAny>(dataSchema: T) =>
  BaseApiResponseSchema.extend({
    data: dataSchema.optional(),
  });

// Define the ApiResponse type
export type ApiResponse<T> = z.infer<
  ReturnType<typeof ApiResponseSchema<z.ZodType<T>>>
>;

export const GenericApiResponseSchema = z.object({
  status: z.enum(["success", "error"]),
  message: ResponseMessageSchema.optional(),
  pagination: PaginationInfoSchema.optional(),
  authToken: AuthTokenSchema.optional(),
});
export type GenericApiResponse = z.infer<typeof GenericApiResponseSchema>;

export const GenericApiErrorResponseSchema = z.object({
  status: StatusSchema,
  code: ErrorCodes.optional(),
  message: ResponseMessageSchema,
  data: z.null(),
});
export type GenericApiErrorResponse = z.infer<
  typeof GenericApiErrorResponseSchema
>;

export const SystemRoleNameEnum = z.enum([
  "Super Admin",
  "Admin",
  "Main User",
  "Sub User",
  "Inspector",
]);
export const SystemRoleIdentifierEnum = z.enum([
  "super_admin",
  "admin",
  "main_User",
  "sub_user",
  "inspector",
]);

export type SystemRoleName = z.infer<typeof SystemRoleNameEnum>;
export type SystemRoleIdentifier = z.infer<typeof SystemRoleIdentifierEnum>;

export const SystemRoleSchema = z.object({
  NAME: SystemRoleNameEnum,
  ID: z.number().int().positive(),
  IDENTIFIER: SystemRoleIdentifierEnum,
});

export const SystemRolesSchema = z.object({
  ADMIN: SystemRoleSchema,
  SUPER_ADMIN: SystemRoleSchema,
  MAIN_USER: SystemRoleSchema,
  SUB_USER: SystemRoleSchema,
  INSPECTOR: SystemRoleSchema,
});
export type SystemRoles = z.infer<typeof SystemRolesSchema>;

/**
 * Coerces common string representations of booleans into actual booleans.
 *
 * - Accepts "true", "1" => true
 * - Accepts "false", "0" => false
 * - Leaves all other values unchanged, allowing Zod to handle invalid values
 *
 * This is useful for:
 * - Parsing query parameters (e.g. `?flag=true`)
 * - Form data where checkbox values may come as strings
 *
 * @returns A Zod schema that parses a boolean with string coercion support
 */
export const coerceBoolean = (): z.ZodEffects<z.ZodBoolean, boolean, unknown> =>
  z.preprocess((val) => {
    if (val === "true" || val === "1") return true;
    if (val === "false" || val === "0") return false;
    return val;
  }, z.boolean());
